import React, { Component } from 'react';

import './index.css';
import Canvas from '../Canvas';
import Header from '../Header'
import Footer from '../Footer'

class Body extends Component {
  constructor(props)
  {
    super(props);

 
  }



  componentDidMount() 
  {

  }





  render() {

    return (
      <div className="odieworks_body ow_body_clearfix">
      
       <div className="odieworks_site_wrapper" > 
       
        
          <div className='owgs_template_bookends'>   
            <div id='owgs_template_header'>
              <Header />
            </div>
          </div>


          <Canvas>
            {this.props.children}
          </Canvas>
       

          <div className='owgs_template_bookends'>
            <div id='owgs_template_footer'>
              <Footer />
            </div>
          </div>


        </div>
      
      </div>
    );
  }
}

export default Body;
